import React from "react";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import _ from "lodash";
import { invalid } from "@codeArt/utils/common";
import clsx from "clsx";
import { Radio } from "@material-ui/core";
import { changed, memo } from "@codeArt/components/common";

const headerCellClassName = "m-bg-light c-lt";

const useStyles = makeStyles(theme => ({
  root: {
    overflow: "hidden"
  }
}));

const _Header = ({
  order,
  rows,
  columns,
  headers,
  headerDisablePadding,
  headerClassName,
  go,
  radioName,
  /*  isSelected,
   getRowKey, */
  numSelected,
  handleSelectAllClick,
  handleRequestSort,
  getRowDisabled,
  checkbox,
  radio,
  width,
  offset
}) => {
  const classes = useStyles();

  if (headers === false) return null;

  let style = {};
  let fixed = !invalid(width);
  if (fixed) {
    style = { marginLeft: `-${offset}px`, width, minWidth: "100%" };
  }

  return (
    <div className={clsx("d-flex flex-column", classes.root)}>
      <Table style={style}>
        <DataTableHead
          /* numSelected={rows.filter(row => isSelected(getRowKey(row))).length} */
          numSelected={numSelected}
          order={order}
          // orderBy={orderBy}
          onSelectAllClick={handleSelectAllClick}
          onRequestSort={handleRequestSort}
          selectableRowCount={_.filter(rows,(row)=> !getRowDisabled(row)).length}
          rowCount={rows.length}
          headers={headers}
          columns={columns}
          headerClassName={headerClassName}
          headerDisablePadding={headerDisablePadding}
          checkbox={checkbox}
          radio={radio}
          radioName={radioName}
          go={go}
          fixed={fixed}
        />
      </Table>
    </div>
  );
};

const Header = React.memo(_Header, (prevProps, nextProps) => {
  return memo(prevProps, nextProps, ["offset", "numSelected"]);
});

export { Header };

class DataTableHead extends React.Component {
  static propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    // orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
  };

  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  byColumns() {
    const {
      columns,
      order,
      orderBy,
      go,
      headerDisablePadding,
      headerClassName,
      fixed
    } = this.props;
    let c = columns.map((column, i) => {
      return (
        <TableCell
          className={`${headerCellClassName} ${headerClassName}`}
          key={i}
          align={column.align}
          width={column.width || "auto"}
          padding={headerDisablePadding ? "none" : "normal"}
          style={{ whiteSpace: "nowrap" }}
        >
          {column.label}
        </TableCell>
      );
    }, this);
    if (go)
      c.push(
        <GoTD
          key={"go-td"}
          go={go}
          headerDisablePadding={headerDisablePadding}
          headerClassName={headerClassName}
        />
      );

    if (fixed) {
      //如果是固定表格，那么需要一个占位格子，以免内容不足以铺满全屏
      c.push(
        <PlaceholderTD
          key={"placeholder-td"}
          headerDisablePadding={headerDisablePadding}
          headerClassName={headerClassName}
        />
      );
    }
    return c;
  }

  byHeaders() {
    const { headers, disablePadding } = this.props;
    return headers.map((header, i) => {
      return (
        <TableCell
          className={headerCellClassName}
          key={i}
          align={header.align}
          width={header.width || "auto"}
          colSpan={header.colspan || header.colSpan || 1}
          padding={header.disablePadding || disablePadding ? "none" : "normal"}
          style={{ whiteSpace: header.nowrap === false ? "normal" : "nowrap" }}
        >
          {header.component ? header.component() : header.label}
        </TableCell>
      );
    }, this);
  }

  render() {
    const {
      onSelectAllClick,
      numSelected,
      selectableRowCount,
      rowCount,
      checkbox,
      radio,
      headers,
      radioName
    } = this.props;
    return (
      <TableHead>
        <TableRow>
          <SelectTD
            checkbox={checkbox}
            radio={radio}
            radioName={radioName}
            numSelected={numSelected}
            selectableRowCount={selectableRowCount}
            rowCount={rowCount}
            onSelectAllClick={onSelectAllClick}
          />
          {headers ? this.byHeaders() : this.byColumns()}
        </TableRow>
      </TableHead>
    );
  }
}

const SelectTD = ({
  checkbox,
  radio,
  radioName,
  numSelected,
  rowCount,
  selectableRowCount,
  onSelectAllClick
}) => {
  if (checkbox)
    return (
      <TableCell padding="checkbox" className={headerCellClassName}>
        <Checkbox
          color="primary"
          indeterminate={numSelected > 0 && numSelected < selectableRowCount}
          checked={numSelected === selectableRowCount}
          onChange={onSelectAllClick}
        />
      </TableCell>
    );

  if (radio)
    return (
      <TableCell padding="checkbox" className={headerCellClassName}>
        <Radio
          name={radioName + "-header"}
          color="primary"
          checked={numSelected > 0}
          onClick={onSelectAllClick}
        />
      </TableCell>
    );

  return null;
};

const GoTD = ({ go, headerDisablePadding, headerClassName }) => {
  return (
    <TableCell
      className={`${headerCellClassName} ${headerClassName}`}
      key={"header-go"}
      align={"center"}
      width={"50px"}
      padding={headerDisablePadding ? "none" : "normal"}
      style={{ whiteSpace: "nowrap" }}
    />
  );
};

const PlaceholderTD = ({ headerDisablePadding, headerClassName }) => {
  return (
    <TableCell
      className={`${headerCellClassName} ${headerClassName}`}
      key={"header-placehloder"}
      align={"center"}
      width={"auto"}
      padding={"none"}
    />
  );
};
